import { Component } from '@angular/core';
import { ModalModule, ModalRef } from '@vinnova/ui';

@Component({
  selector: 'lib-change-lang-modal',
  templateUrl: './change-lang-modal.component.html',
  styleUrls: ['./change-lang-modal.component.scss'],
  imports: [ModalModule],
})
export class ChangeLangModalComponent {
  modalRef: ModalRef;
}
